import React from "react";
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {NodeType} from "../../../../../model/ModelData";
import {KnowledgeBaseSettings} from "../settings/KnowledgeBaseSettings";
import {menuItemsInfo} from "../editMenuItems";
import {fieldSx} from "../editMenuStyles";
import {SectionHeader} from "../components/EditMenuSection";

export const KnowledgeBaseTab = ({node, setNode, onUpdate, project}) => {
    const {primary, secondary} = menuItemsInfo.knowledge_base;

    const setData = (key, value) => setNode(prev => ({...prev, data: {...prev.data, [key]: value}}));

    return (
        <>
            <SectionHeader title={primary} description={secondary}/>

            <TextField
                label="QA Api"
                size="small"
                value={node?.data?.qa_api}
                InputLabelProps={{shrink: true}}
                sx={fieldSx}
                onBlur={() => onUpdate(node)}
                onChange={(e) => setData("qa_api", e.target.value)}
            />
            <FormControl size="small" fullWidth sx={fieldSx}>
                <InputLabel id="kb-qa-method-label">QA Method</InputLabel>
                <Select
                    labelId="kb-qa-method-label"
                    value={node?.data?.qa_method || null}
                    label="QA Method"
                    onBlur={() => onUpdate(node)}
                    onChange={(e) => setData("qa_method", e.target.value)}
                >
                    <MenuItem value={null}><em>None</em></MenuItem>
                    <MenuItem value="GET">GET</MenuItem>
                    <MenuItem value="POST">POST</MenuItem>
                    <MenuItem value="PUT">PUT</MenuItem>
                    <MenuItem value="PATCH">PATCH</MenuItem>
                </Select>
            </FormControl>

            {node?.type !== NodeType.QA && (
                <KnowledgeBaseSettings node={node} setNode={setNode} onUpdate={onUpdate} project={project}/>
            )}
        </>
    );
};
